/* ob-offres.js — sélecteur d'offres natif (remplace Moon Bundles, 20/10).
   Gabarits figés par palier (snippets/ob-gabarit-<handle>.liquid), configuration (snippets/ob-offres-config.liquid,
   tirée de offres.json). Le prix payé vient des réductions automatiques natives : ce script ne fixe aucun prix,
   il met les bonnes lignes au panier (variantes, quantités, cadeaux) et affiche le palier choisi. */
(function () {
  'use strict';
  if (window.ObOffres) return;

  function lire(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function ecrire(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } }

  function Widget(racine) {
    this.r = racine;
    var s = racine.querySelector('script[data-ob-config]');
    this.cfg = JSON.parse(s.textContent);
    this.tpl = {};
    var self = this;
    [].forEach.call(racine.querySelectorAll('template[data-ob-etat]'), function (t) {
      self.tpl[t.getAttribute('data-ob-etat')] = t;
    });
    this.mount = racine.querySelector('[data-ob-mount]');
    this.cle = 'ob-palier-' + this.cfg.produit;
    this.couleurs = {};   // couleurs choisies PAR PALIER, gardées tant que la page est ouverte (comme Moon)
    this.cadeauxCouleurs = {};   // couleur de chaque cadeau à couleurs (pyjama Rose / Blanc), PAR PALIER, idem
    this.sansUpsell = {};
    var memo = parseInt(lire(this.cle), 10);
    this.n = (memo && this.tpl[String(memo)]) ? memo : this.cfg.defaut;
    if (this.etat() !== this.mount.getAttribute('data-ob-etat')) this.afficher();
    this.brancher();
    this.majBouton();
    this.express();
  }

  Widget.prototype.etat = function () {
    var e = String(this.n);
    if (this.sansUpsell[this.n] && this.tpl[e + 'u']) e += 'u';
    return e;
  };

  Widget.prototype.optionActive = function () {
    return this.mount.querySelectorAll('.ob-option-wrapper')[this.n - 1] || null;
  };

  /* mise à jour EN PLACE (comme Svelte chez Moon) : seules les classes, attributs et textes qui changent sont
     touchés, donc les transitions CSS du widget (0,2 s sur l'upsell…) jouent comme chez Moon */
  function morph(a, b) {
    if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) { a.parentNode.replaceChild(b, a); return; }
    if (a.nodeType === 3 || a.nodeType === 8) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
    if (a.nodeType !== 1) return;
    var i, at;
    for (i = a.attributes.length - 1; i >= 0; i--) {
      at = a.attributes[i].name;
      if (!b.hasAttribute(at)) a.removeAttribute(at);
    }
    for (i = 0; i < b.attributes.length; i++) {
      at = b.attributes[i];
      if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value);
    }
    if (a.nodeName === 'INPUT') a.checked = b.hasAttribute('checked');
    var ac = [].slice.call(a.childNodes), bc = [].slice.call(b.childNodes);
    for (i = 0; i < Math.min(ac.length, bc.length); i++) morph(ac[i], bc[i]);
    for (i = bc.length; i < ac.length; i++) a.removeChild(ac[i]);
    for (i = ac.length; i < bc.length; i++) a.appendChild(bc[i]);
  }

  Widget.prototype.afficher = function () {
    var e = this.etat();
    var t = this.tpl[e];
    if (!t) return;
    var neuf = t.content.cloneNode(true), self = this;
    var ancien = this.mount.firstElementChild, nouveau = neuf.firstElementChild;
    if (ancien && nouveau && !this.mount.children[1]) morph(ancien, nouveau);
    else { this.mount.innerHTML = ''; this.mount.appendChild(neuf); }
    this.mount.setAttribute('data-ob-etat', e);
    var act = this.optionActive();
    if (act) {
      [].forEach.call(act.querySelectorAll('.ob-variants-box select'), function (sel, i) {
        var v = (self.couleurs[self.n] || [])[i], def = sel.querySelector('option[selected]');
        if (v && [].some.call(sel.options, function (o) { return o.value === v; })) sel.value = v;
        else if (def) sel.value = def.value;
      });
      [].forEach.call(act.querySelectorAll('.ob-cadeau-box select'), function (sel) {
        var v = (self.cadeauxCouleurs[self.n] || [])[parseInt(sel.getAttribute('data-ob-cadeau'), 10)];
        var def = sel.querySelector('option[selected]');
        if (v && [].some.call(sel.options, function (o) { return o.value === v; })) sel.value = v;
        else if (def) sel.value = def.value;
      });
    }
    this.majBouton();
    this.express();
  };

  Widget.prototype.brancher = function () {
    var self = this;
    this.mount.addEventListener('click', function (ev) {
      var w = ev.target.closest('.ob-option-wrapper');
      if (!w || !self.mount.contains(w)) return;
      var liste = [].slice.call(self.mount.querySelectorAll('.ob-option-wrapper'));
      var n = liste.indexOf(w) + 1;
      if (n < 1 || n === self.n) return;
      if (ev.target.closest('select, option, .ob-upsells-container')) return;
      self.n = n;
      ecrire(self.cle, String(n));
      self.afficher();
    });
    this.mount.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.matches('.ob-variants-box select')) {
        var act = self.optionActive();
        var sels = act ? [].slice.call(act.querySelectorAll('.ob-variants-box select')) : [];
        var i = sels.indexOf(t);
        if (i >= 0) (self.couleurs[self.n] = self.couleurs[self.n] || [])[i] = t.value;
        self.express();
      } else if (t.matches('.ob-cadeau-box select')) {
        var a2 = self.optionActive(), j = parseInt(t.getAttribute('data-ob-cadeau'), 10);
        if (a2 && a2.contains(t) && j >= 0) (self.cadeauxCouleurs[self.n] = self.cadeauxCouleurs[self.n] || [])[j] = t.value;
      } else if (t.matches('.ob-upsell-checkbox-input')) {
        self.sansUpsell[self.n] = !t.checked;
        self.afficher();
      }
    });
    // le formulaire d'ajout du produit (même fiche) : on prend la main avant le thème
    var portee = this.r.closest('.product__info-container') || this.r.closest('section') || document;
    this.form = portee.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    if (!this.form) return;
    this.pf = this.form.closest('product-form') || this.form.parentElement;
    this.pf.addEventListener('submit', function (ev) {
      if (ev.target !== self.form) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      self.ajouter();
    }, true);
    if (this.cfg.boutonPrix) {
      new MutationObserver(function () {
        if (self._maj) return;
        self._maj = true;
        setTimeout(function () { self._maj = false; self.majBouton(); }, 30);
      }).observe(this.form, { subtree: true, childList: true, characterData: true, attributes: true,
                              attributeFilter: ['class', 'disabled'] });
    }
  };

  /* lignes du palier : variantes choisies (couleur par tube), cadeaux, upsell coché — même ordre que Moon */
  Widget.prototype.lignes = function () {
    var p = this.cfg.paliers[this.n - 1], self = this, out = [], principales = [];
    var offre = this.cfg.handle + ' · ' + p.titre;
    var act = this.optionActive();
    if (this.cfg.parUnite) {
      var sels = act ? act.querySelectorAll('.ob-variants-box select') : [];
      var parId = {}, ordre = [];
      for (var i = 0; i < p.quantite; i++) {
        var titre = sels[i] ? sels[i].value : null;
        var v = (titre && this.cfg.variantes[titre]) || p.principal[0].variante;
        if (!parId[v]) { parId[v] = 0; ordre.push(v); }
        parId[v]++;
      }
      ordre.forEach(function (v) { principales.push({ id: v, quantity: parId[v], properties: { _ob_offre: offre } }); });
    } else {
      p.principal.forEach(function (l) {
        principales.push({ id: l.variante, quantity: l.quantite, properties: { _ob_offre: offre } });
      });
    }
    // cadeaux et upsell de l'offre : les copies à 0 € (absentes avant la bascule : rien n'est ajouté)
    var copies = this.cfg.copies || {};
    p.cadeaux.forEach(function (c, j) {
      var ref = copies[c.cle], id = ref;
      if (ref && typeof ref === 'object') {
        // cadeau à couleurs (pyjama) : la couleur choisie sur SA ligne (pastilles), sinon la 1re ; absente → la 1re dispo
        var sel = act && act.querySelector('.ob-cadeau-box select[data-ob-cadeau="' + j + '"]');
        id = ref[(sel && sel.value) || (c.couleurs || [])[0]];
        if (!id) Object.keys(ref).some(function (k) { id = ref[k]; return !!id; });
      }
      if (!id) { if (window.console) console.warn('ob-offres : copie cadeau absente', c.cle); return; }
      out.push({ id: id, quantity: 1, properties: { _ob_offre: offre, _ob_cadeau: c.texte || 'Offert' } });
    });
    p.upsells.forEach(function (u) {
      if (self.sansUpsell[self.n]) return;
      var id = copies[u.cle];
      if (!id) { if (window.console) console.warn('ob-offres : copie upsell absente', u.cle); return; }
      out.push({ id: id, quantity: u.quantite || 1, properties: { _ob_offre: offre, _ob_cadeau: u.titre } });
    });
    return out.concat(principales);
  };

  Widget.prototype.ajouter = function () {
    var self = this, btn = this.form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var sp = this.pf.querySelector('.loading__spinner');
    if (sp) sp.classList.remove('hidden');
    var fin = function () {
      if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      if (sp) sp.classList.add('hidden');
    };
    var lignes = this.lignes();
    var envoyer = function (items) {
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Ob-Tiroir': '1' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    };
    var estCadeau = function (l) { return !!(l.properties && l.properties._ob_cadeau); };
    envoyer(lignes)
      .then(function (res) {
        // un cadeau refusé (copie indisponible) ne bloque jamais l'achat : nouvel essai sans les cadeaux
        if ((!res.ok || res.j.status) && lignes.some(estCadeau)) {
          if (window.console) console.warn('ob-offres : ajout refusé avec les cadeaux, nouvel essai sans', res.j);
          return envoyer(lignes.filter(function (l) { return !estCadeau(l); }));
        }
        return res;
      })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          fin();
          var msg = (res.j && (res.j.description || res.j.message)) || '';
          self.erreur(msg);
          if (window.ObTiroir) window.ObTiroir.erreur(msg);
          return;
        }
        // le bouton reste occupé jusqu'à l'ouverture du tiroir (synchro, cadeaux) : un second tap n'ajoute pas l'offre une
        // deuxième fois (8 s au plus)
        if (window.ObTiroir) {
          var garde = setTimeout(fin, 8000);
          var libere = function () { clearTimeout(garde); fin(); };
          return Promise.resolve(window.ObTiroir.rafraichir({ ouvrir: true, source: 'ob-offres' })).then(libere, libere);
        }
        fin();
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { fin(); self.erreur(''); if (window.ObTiroir) window.ObTiroir.erreur(''); });
  };

  /* erreur d'ajout : le message du thème (zone d'erreur du formulaire), texte Moon par défaut */
  Widget.prototype.erreur = function (msg) {
    var w = this.pf && this.pf.querySelector('.product-form__error-message-wrapper');
    var t = w && w.querySelector('.product-form__error-message');
    if (!w || !t) return;
    t.textContent = msg || 'Ce produit n\'a pas pu être ajouté. Réessayez.';
    w.removeAttribute('hidden');
  };

  /* bouton « Ajouter au panier · prix + barré » (choix B de Matt, 20/10) — même rendu que le customJs Moon */
  Widget.prototype.majBouton = function () {
    if (!this.cfg.boutonPrix || !this.form) return;
    var btn = this.form.querySelector('button[name="add"]'), act = this.mount.querySelector('.ob-option.ob-option-active');
    if (!btn || !act || btn.disabled) return;
    var span = btn.querySelector('span');
    if (!span) return;
    var p = act.querySelector('.ob-option-new-price, .ob-option-single-price');
    var o = act.querySelector('.ob-option-old-price');
    var prix = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
    var barre = o ? o.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!prix) return;
    var base = (span.textContent.split('·')[0] || '').trim() || 'Ajouter au panier';
    var html = base + ' · ' + prix + (barre && barre !== prix
      ? ' <s class="oralya-atc-barre" style="opacity:.6;font-weight:400;font-size:.78em;margin-left:.2em">' + barre + '</s>' : '');
    var serre = window.matchMedia('(max-width: 749px)').matches;
    span.style.letterSpacing = serre ? '.02em' : '';
    span.style.fontSize = serre ? '15px' : '';
    if (span.innerHTML !== html) span.innerHTML = html;
  };

  /* boutons de paiement express du formulaire (« Acheter maintenant », Shop Pay) : ils paient le contenu du FORMULAIRE
     (1 article), pas l'offre. Moon les cachait dès que l'offre choisie avait un cadeau, un upsell coché ou plusieurs
     variantes (displayExpressCheckout) ; ici, cachés aussi dès que l'offre compte plus d'un article, sinon ils feraient
     payer 1 article au lieu de l'offre (masque : 1 × 44,95 € au lieu de 2+3 à 47,95 €). Au 21/10, seul le modèle du
     masque affiche « Acheter maintenant », et ses 3 offres ont un cadeau : toujours cachés, comme avec Moon. */
  Widget.prototype.express = function () {
    if (!this.form) return;
    var p = this.cfg.paliers[this.n - 1], champ = this.form.querySelector('[name="id"]');
    var simple = !!p && !p.cadeaux.length && !(p.upsells.length && !this.sansUpsell[this.n]) && p.quantite === 1;
    if (simple) { var l = this.lignes()[0]; simple = !!(l && champ && String(champ.value) === String(l.id)); }
    this.form.classList.toggle('ob-sans-express', !simple);
  };

  window.ObOffres = { widgets: [] };
  function demarrer() {
    if (!document.getElementById('ob-express-css')) {
      var st = document.createElement('style');
      st.id = 'ob-express-css';
      st.textContent = 'form.ob-sans-express .shopify-payment-button,form.ob-sans-express shopify-accelerated-checkout{display:none!important}';
      (document.head || document.documentElement).appendChild(st);
    }
    [].forEach.call(document.querySelectorAll('.ob-offres:not([data-ob-pret])'), function (r) {
      r.setAttribute('data-ob-pret', '1');
      try { window.ObOffres.widgets.push(new Widget(r)); } catch (e) { if (window.console) console.error('ob-offres', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
